import { useInsuranceFormType } from 'hookApi';

export const FormView = ({ children }) => {
  const formType = useInsuranceFormType();

  if (formType !== 'RegisterFormView') {
    return null;
  }

  return children;
};
